import BaseObject from "../models/BaseObject";

export default class Clipboard extends BaseObject {
  public get className(): string {
    return "Clipboard"; // no itx
  }

  setDescription(description: string) {
    localStorage.setItem("clipboard_description", description);
    this.raiseOnChange();
  }

  getDescription(): string {
    return localStorage.getItem("clipboard_description") || "";
  }

  setData(data: string, className: string) {
    localStorage.setItem("clipboard", data);
    localStorage.setItem("clipboard_className", className);
    this.raiseOnChange();
  }
  getData(): string | null {
    return localStorage.getItem("clipboard");
  }
  getClassName(): string | null {
    return localStorage.getItem("clipboard_className");
  }
  clear() {
    localStorage.removeItem("clipboard");
    localStorage.removeItem("clipboard_className");
  }
}
